import { default as axios, AxiosStatic, AxiosInstance } from 'axios';
import AuthManager from '@/auth';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from './store/index';

export interface IAxiosOptions {
    baseUrl: string;
    resourceId: string;
}

const getToken = (resource: any, http: any, cb: any) => {
    const ctx = AuthManager.Instance.authenticationContext;
    ctx.acquireToken(resource, (err, token) => {
        if (err) {
            const errCode = err.split(':')[0];
            switch (errCode) {
                case 'AADSTS50058': // Need to prompt for user sign in
                    ctx.login();
                    break;
                case 'AADSTS65001': // Token is invalid; grab a new one
                    ctx.acquireTokenRedirect(resource);
                    break;
                case 'AADSTS16000': // No Access
                default:
                    // Need a pop-up forcing a login
                    ctx.login();
                    break;
            }
            cb(new Error('Failed to acquire token'));
            return;
        }
        /* tslint:disable:no-string-literal */
        http.defaults.headers['Authorization'] = `BEARER ${token}`;
        /* tslint:disable:no-string-literal */

        cb(null, token);
    });
};

export class AxiosAuthHttp {
    public static CreateClient(options: IAxiosOptions): AxiosInstance {

        const ctx = AuthManager.Instance.authenticationContext;

        let accessToken = null;
        ctx.acquireToken(options.resourceId, (err, token) => {
            if (err) {
                const errCode = err.split(':')[0];
                console.log('Error in token acquire' + errCode);
                switch (errCode) {
                    case 'AADSTS50058': // Need to prompt for user sign in
                        ctx.login();
                        break;
                    case 'AADSTS65001': // Token is invalid; grab a new one
                        ctx.acquireTokenRedirect(options.resourceId);
                        break;
                    case 'AADSTS16000': // No Access
                    default:
                        // Need a pop-up forcing a login
                        ctx.login();
                        break;
                }
            }
            /* tslint:disable:no-string-literal */
            accessToken = `BEARER ${token}`;
        });

        const http = axios.create({
            baseURL: options.baseUrl,
            headers: {
                Authorization: accessToken,
            },
        });

        http.interceptors.request.use((config) => {
            NProgress.start();
            return config;
        });

        http.interceptors.response.use((response) => {
            NProgress.done();
            return response;
        }, (error) => {
            NProgress.done();
            if (!error.response) {
                store.commit('AppStore/SNACK_BAR', {
                    text: 'Unable to communicate with server',
                    show: true,
                });
                return Promise.reject(error);
            } else if (error.response.status === 422) {
                store.commit('AppStore/SNACK_BAR', {
                    text: error.response.data.Message,
                    show: true,
                });
                return Promise.reject(error);
            } else if (error.response.status === 404) {
                window.location.assign('/404');
                return Promise.reject(error);
            } else if (error.response.status === 403) {
                window.location.assign('/forbidden');
                return Promise.reject(error);
            } else if (error.response.status === 401) {
                ctx.clearCacheForResource(options.resourceId);
                return new Promise((resolve, reject) => getToken(options.resourceId, http, () => {
                    const config = error.response.config;
                    config.headers.Authorization = http.defaults.headers['Authorization'];
                    http({
                        method: config.method,
                        url: config.url,
                        data: config.data,
                        headers: {
                            'Accept': config.headers['Accept'],
                            'Authorization': config.headers['Authorization'],
                            'Content-Type': config.headers['Content-Type'],
                            'Access-Control-Allow-Origin': '*',
                        },
                    }).then((res) => resolve(res), (err) => reject(err));
                }));
            } else {
                return Promise.reject(error);
            }
        });

        return http;
    }
}
